export default __webpack_public_path__ + "static/media/IMG_2158.77388b51.JPG";